import './stylePanel.scss';

import { createPinia } from 'pinia';
import { createApp } from 'vue';

import PanelPage from './pages/PanelPage.vue';
import { initStreamerApi } from './apiClients';
import { i18n } from './i18nSetup';
import { addSentryPiniaPlugin, initSentry } from './sentrySetup';

const i18Plugin = i18n();
const pinia = createPinia();
addSentryPiniaPlugin(pinia);

initStreamerApi();

const panelApp = createApp(PanelPage).use(pinia).use(i18Plugin);

initSentry(panelApp);

panelApp.mount('#app');
